import { Component, OnInit, ElementRef, HostListener, ChangeDetectorRef, AfterContentChecked, SimpleChanges } from '@angular/core';
import { ColDef, GridReadyEvent, GridApi} from 'ag-grid-community';
import { ResolutionViewService } from '../Services/resolution-view.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import * as Global from "../Models/constants";
import { SCREEN_SIZE, ResolutionInputModel, ResolutionStatus, ResolutionsViewResults } from '../Models/common.model';
import { Title } from '@angular/platform-browser';

declare var ReadStaticData;
let response: string;
@Component({
    selector: 'resolution-view',
    templateUrl: './resolution-view.component.html',
    styles: []
})
export class ResolutionViewComponent implements OnInit, AfterContentChecked {
    dropdownSettings: {};
    dropdownList = [];
    form: FormGroup;
    private formBuilder: FormBuilder;
    public rowData!: any[];
    private gridApi!: GridApi;
    public formGroup: FormGroup;
    public loadContent: boolean = false;
    public paginationPageSize = 10;
    public domLayout: string = Global.domLayout;
    public noRowsTemplate: string = Global.noRowsTemplate;
    public loadingTemplate: string = Global.loadingTemplate;
    dateErrorMessage: string = Global.dateRangeErrorMessage;
    public SelectedResolutions: any[];
    public startDate: string;
    public endDate: string;
    isRequired: boolean = true;
    isValidDate: boolean = true;
    public pagination: boolean = true;

    resolutionInputModel: ResolutionInputModel;
    private _resolutionsViewResults: ResolutionsViewResults[];
    get resolutionsViewResults(): ResolutionsViewResults[] {
        return this._resolutionsViewResults;
    }
    set resolutionsViewResults(value: ResolutionsViewResults[]) {
        this._resolutionsViewResults = value;
    }
    prefix = 'is-';
    size: SCREEN_SIZE;
    sizes = [
        {
            id: SCREEN_SIZE.XS, name: 'xs', css: `d-block d-sm-none`
        },
        {
            id: SCREEN_SIZE.SM, name: 'sm', css: `d-none d-sm-block d-md-none`
        },
        {
            id: SCREEN_SIZE.MD, name: 'md', css: `d-none d-md-block d-lg-none`
        },
        {
            id: SCREEN_SIZE.LG, name: 'lg', css: `d-none d-lg-block d-xl-none`
        },
        {
            id: SCREEN_SIZE.XL, name: 'xl', css: `d-none d-xl-block`
        },
    ];
    resolutionsInputModel: ResolutionInputModel;
    resolutionStatus: ResolutionStatus;

    @HostListener("window:resize", [])
    private onResize() {
        this.detectScreenSize();
    }

    ngAfterViewInit() {
        this.detectScreenSize();
    }

    ngAfterContentChecked(): void {
        this.cdRef.detectChanges()
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {

        }
    }

    private detectScreenSize() {
        const currentSize = this.sizes.find(x => {
            // get the HTML element
            const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);

            // check its display property value
            const isVisible = window.getComputedStyle(el).display != 'none';

            if (!isVisible) {
                return false;
            }
            else {
                return isVisible;
            }
        });

        this.dataService.onResize(currentSize.id);
    }
    constructor(public dataService: ResolutionViewService, private elementRef: ElementRef, private cdRef: ChangeDetectorRef, private fb: FormBuilder,
        private titleService: Title) {
        this.dataService.onResize$.subscribe(x => {
            this.size = x;
            if (this.size == 0 || this.size == 1) {
                this.columnDefs = this.columnDefsClosed_OnExcluded;
            }
            else {
                this.columnDefs = this.columnDefsClosed_OnIncluded;
            }      
        });
    }

    ngOnInit(): void {
        this.form = new FormGroup({});
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'Status',
            textField: 'Description',
            itemsShowLimit: 6,
            allowSearchFilter: false,
        };
        this.setFormvalues(ReadStaticData());
    }

    setFormvalues(inputFields: any) {
        this.resolutionInputModel = JSON.parse(inputFields);
        this.startDate = this.resolutionInputModel.StartDate;
        this.endDate = this.resolutionInputModel.EndDate;
        for (let control in this.resolutionInputModel) {
            this.form.addControl(control.toString(), new FormControl(null));
            if (control.toLocaleUpperCase() == "STARTDATE" || control.toLocaleUpperCase() == "ENDDATE") {
                this.form.get(control).patchValue(this.resolutionInputModel[control]);
            }
        }
        this.SelectedResolutions = this.resolutionInputModel.ResolutionStatuses;
    }

    public defaultColDef: ColDef = {
        flex: 1,
    };

    public columnDefs: ColDef[] = [
        { field: 'ResodbId', hide: true },
        { field: 'ResolutionNo', headerName: 'Number', resizable: true },
        { field: 'Annotationid', hide: true },
        {
            field: 'Attachment', headerName: '', cellRenderer: function (params) {
                let attachmentsCount = params.data.AttachmentCount;
                return (attachmentsCount > 1 ? `<span class="attachment-icon" style="min-width: 15px; flex-shrink: 0;" title="${attachmentsCount}"></span>` : '')
            }, maxWidth: 30
        },
        {
            field: 'Title', cellRenderer: function (params) {
                let newLink = `<div style="display: flex; align-items: center; width: 100%;">` +
                    `<span class="swapa-resolution viewResolutions1_tvResolutions_0 viewResolutions1_tvResolutions_1" id="viewResolutions1_tvResolutionst0" title="${params.value}" name="${params.value}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex-grow: 1;">${params.value}</span>` +
                    `</div>`;
                return newLink;
            }, minWidth: 250, maxWidth: 400, resizable: true,
            onCellClicked(params) {
                let newWindow = window.open(window.location.origin + "/internal/resotrackdownloadfile/attachment?attachmentId=" + params.data.Annotationid, '_blank');
                newWindow.onload = function () {
                    setInterval(() => {
                        newWindow.document.title = params.data.ResolutionNo + " - " + params.value;
                    }, 100)
                }
            },
        },
        { field: 'PDFLink', hide: true },
        { field: 'Status', minWidth: 180, maxWidth: 300, flex: 1, resizable: true, lockPosition: true, cellClass: 'locked-col' },
        {
            field: 'ClosedDateInStringFormat', sortable: true, minWidth: 150, sortingOrder: ['asc', 'desc'], sort: 'desc', headerName: "Closed On", resizable: false, comparator: dateComparator, lockPosition: true, cellClass: 'locked-col'
        }
    ];

    columnDefsClosed_OnIncluded: ColDef[] = [
        { field: 'ResodbId', hide: true },
        { field: 'ResolutionNo', headerName: 'Number', resizable: true, minWidth: 85, maxWidth: 110 },
        { field: 'Annotationid', hide: true },
        {
            field: 'Title', cellRenderer: function (params) {
                let newLink = `<div style="display: flex; align-items: center; width: 100%;">` +
                    `<span class="swapa-resolution viewResolutions1_tvResolutions_0 viewResolutions1_tvResolutions_1" id="viewResolutions1_tvResolutionst0" title="${params.value}" name="${params.value}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex-grow: 1;">${params.value}</span>` +
                    `</div>`;
                return newLink;
            }, minWidth: 100, maxWidth: 400, resizable: true,
            onCellClicked(params) {
                let newWindow = window.open(window.location.origin + "/internal/resotrackdownloadfile/attachment?attachmentId=" + params.data.Annotationid, '_blank');
                newWindow.onload = function () {                    
                    setInterval(() => {
                    newWindow.document.title = params.data.ResolutionNo + " - " + params.value;
                    }, 100)
                }
            },
        },
        {
            field: 'Attachment', headerName: '', cellRenderer: function (params) {
                let attachmentsCount = params.data.AttachmentCount;
                return (attachmentsCount > 1 ? `<span class="attachment-icon" style="min-width: 15px; flex-shrink: 0;" title="${attachmentsCount - 1}"></span>` + `<span style="margin-left: -0.3rem">(${attachmentsCount - 1})</span>` : '')
            }, maxWidth: 100, minWidth: 80, cellStyle: {'float': 'left' }
        },
        { field: 'PDFLink', hide: true },
        { field: 'Status', minWidth: 80, maxWidth: 300, resizable: true, lockPosition: true, cellClass: 'locked-col' },
        {
            field: 'ClosedDateInStringFormat', sortable: true, minWidth: 120, sortingOrder: ['asc', 'desc'], sort: 'desc', headerName: "Closed On", resizable: false, comparator: dateComparator, lockPosition: true, cellClass: 'locked-col'
        }
    ];
    columnDefsClosed_OnExcluded: ColDef[] = [
        { field: 'Annotationid', hide: true },
        { field: 'ResolutionNo', headerName: 'Number', resizable: true, maxWidth: 80, minWidth: 70 },
        {
            field: 'Title', cellRenderer: function (params) {
                let keyData = params.data.key;
                let newLink = `<p class="swapa-resolution viewResolutions1_tvResolutions_0 viewResolutions1_tvResolutions_1"  id="viewResolutions1_tvResolutionst0" title="` + params.value + `" name="` + params.value + `">` + params.value + `</p>`;
                return newLink;
            }, resizable: true, minWidth: 70,
            onCellClicked(params) {
                let newWindow = window.open(window.location.origin + "/internal/resotrackdownloadfile/attachment?attachmentId=" + params.data.Annotationid, '_blank');
                newWindow.onload = function () {
                    setInterval(() => {
                        newWindow.document.title = params.data.ResolutionNo + " - " + params.value;
                    }, 100)
                }
                
            },
        },
        {
            field: 'Attachment', headerName: '', cellRenderer: function (params) {
                let attachmentsCount = params.data.AttachmentCount;
                return (attachmentsCount > 1 ? `<span class="attachment-icon" style="min-width: 15px; flex-shrink: 0;" title="${attachmentsCount - 1}"></span>` + `<span style="margin-left: -0.3rem">(${attachmentsCount - 1})</span>` : '')
            }, maxWidth: 100, minWidth: 80, cellStyle: { 'float': 'left' }
        },
        { field: 'ClosedDateInStringFormat', sortable: true, minWidth: 100, sortingOrder: ['asc', 'desc'], sort: 'desc', headerName: "Closed On", resizable: false, comparator: dateComparator, lockPosition: true, cellClass: 'locked-col' },

    ];



    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridApi.setDomLayout("autoHeight");
        response = ReadStaticData();
        this.resolutionsInputModel = JSON.parse(response);
        this.gridApi.showLoadingOverlay();
        this.dataService.getResolutionGridDetails(this.resolutionsInputModel.Keyword, this.resolutionsInputModel.ResolutionStatuses.map(status => status.Description).join(','), this.resolutionsInputModel.StartDate, this.resolutionsInputModel.EndDate, this.resolutionInputModel.Id).subscribe((data: ResolutionsViewResults[]) => {
            this.resolutionsViewResults = data;
            if(this.resolutionsViewResults.length > 0) {
                this.rowData = this.resolutionsViewResults;
            }
            this.gridApi.setRowData(this.rowData);
        })
        params.api.sizeColumnsToFit();
    }

    onCalenderchange(event: any) {
        let formControlName = event.target["name"]
        let formControlValue = event.target["value"];
        this.form.controls[formControlName].setValue(formControlValue);
        this.isValidDate = true;
        if (formControlName == "StartDate") {
            this.startDate = formControlValue;
            if (this.startDate != null && this.startDate != "") {
                this.ValidateDateRange(this.startDate, this.endDate);
            }
        }
        if (formControlName == "EndDate") {
            this.endDate = formControlValue;
            if (this.endDate != null && this.endDate != "") {
                this.ValidateDateRange(this.startDate, this.endDate);
            }
        }
    }

    ValidateDateRange(startDate, endDate) {
        if ((startDate != "" || startDate != null) && (endDate != "" || endDate != null)) {
            if (new Date(startDate.replace(/-/g, "/")) > new Date(endDate.replace(/-/g, "/"))) {
                this.isValidDate = false;
            }
            else {
                this.isValidDate = true;
            }
        }
    }

    getRsolutionGridDetails() {
        var formData = this.form.value;
        if (formData["ResolutionStatuses"].length == 0 && (formData["Keyword"] == null || formData["Keyword"] == "") && (formData["Id"] == null || formData["Id"] == "") && (formData["StartDate"] == "" || formData["StartDate"] == null) && (formData["EndDate"] == "" || formData["EndDate"] == null)) {
            this.isRequired = false;
        }
        else {
            this.isRequired = true;
            var statuses = formData["ResolutionStatuses"].length > 0 ? formData["ResolutionStatuses"].map(status => status.Description).join(',') : null;
            this.getGridData(formData["Keyword"], statuses, formData["StartDate"], formData["EndDate"], formData["Id"])
        }
    }

    getGridData(keyword, statuses, startDate, endDate, id) {
        this.gridApi.showLoadingOverlay();
        this.dataService.getResolutionGridDetails(keyword, statuses, startDate, endDate, id).subscribe((data: ResolutionsViewResults[]) => {
            this.resolutionsViewResults = data;
            this.rowData = []
            if(this.resolutionsViewResults.length > 0) {
                this.rowData = this.resolutionsViewResults;
            }
            if (this.rowData.length == 0) {
                this.elementRef.nativeElement.querySelector(".ag-theme-alpine > .ag-root-wrapper > .ag-paging-panel > .ag-paging-row-summary-panel").setAttribute('class', 'ag-paging-row-summary-panel d-none')
                this.elementRef.nativeElement.querySelector(".ag-theme-alpine > .ag-root-wrapper > .ag-paging-panel > .ag-paging-page-summary-panel").setAttribute('class', 'ag-paging-page-summary-panel d-none')
            }
            else {
                this.elementRef.nativeElement.querySelector(".ag-theme-alpine > .ag-root-wrapper > .ag-paging-panel > .ag-paging-row-summary-panel").setAttribute('class', 'ag-paging-row-summary-panel')
                this.elementRef.nativeElement.querySelector(".ag-theme-alpine > .ag-root-wrapper > .ag-paging-panel > .ag-paging-page-summary-panel").setAttribute('class', 'ag-paging-page-summary-panel')
            }
            this.gridApi.setRowData(this.rowData);
            this.gridApi.paginationGoToPage(0);/// every time the page results will start diplaying from 1st page.
        });

    }

}



function dateComparator(date1: string, date2: string) {
    var date1Number = monthToComparableNumber(date1);
    var date2Number = monthToComparableNumber(date2);

    if (date1Number == null && date2Number == null) {
        return 0;
    }
    if (date1Number == null) {
        return -1;
    }
    if (date2Number == null) {
        return 1;
    }

    return date1Number - date2Number;
}

// eg 29/08/2004 gets converted to 20040829
function monthToComparableNumber(date: string): number {
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }

    const yearNumber = Number.parseInt(date.substring(6, 10));
    const monthNumber = Number.parseInt(date.substring(0, 2));
    const dayNumber = Number.parseInt(date.substring(3, 5));

    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

function dateFormatter(params) {
    var dateAsString = params.data.date;
    var dateParts = dateAsString.split('/');
    return '${dateParts[0]} - ${dateParts[1]} - ${dateParts[2]}';
}